import { PathOptions } from "leaflet";

export const adutoras = (feature: any): PathOptions => {

    return {
      color: "#38a800",
      weight: 1,
      opacity: 1,
      dashArray: "4 2",
    };
  };
